import React from 'react';
import styled from 'styled-components';
import DataRow, {DataColumn} from 'features/POSRegisters/POSDiagram/components/DataGrid/DataRow';
import ModalMainContentContainer from './components/ModalContentContainer';
import DeviceType from 'features/POSRegisters/interfaces/DeviceType';
import ScanDetails from 'features/POSRegisters/interfaces/ScanDetails';
import ModalIconTitle from './components/ModalTitle';
import getPriorityAlert from 'features/POSRegisters/functions/getPriorityAlert';
import {SeverityPriorityEnum} from 'features/POSRegisters/interfaces/Severity';
import Device from 'features/POSRegisters/interfaces/Device';
import TunnelStatusIndicator from 'features/POSRegisters/POSTable/NetworkCircuit/components/TunnelStatusIndicator';
import SGSubtitle from 'components/Typography/SGSubtitle';

const StyledModalContent = styled.div``;

const StyledTunnelStatus = styled.div`
  display: flex;
  align-items: center;
  text-transform: capitalize;
`;

//#region Column Definitions
const networkCircuitColumns: DataColumn[] = [
  {
    id: 'interface',
    label: 'Interface',
    width: '90px',
  },
  {
    id: 'localExchangeCarrier',
    label: 'Local Exchange Carrier',
    width: '180px',
  },
  {
    id: 'ipV4Address',
    label: 'IP Address',
    width: '130px',
  },
  {
    id: 'tunnelStatus',
    label: 'Tunnel Status',
    width: '130px',
    format: (value: ScanDetails) => (
      <StyledTunnelStatus>
        <TunnelStatusIndicator status={value?.tunnelStatus?.toLowerCase()} />
        <SGSubtitle className="s2">{value?.tunnelStatus ?? ''}</SGSubtitle>
      </StyledTunnelStatus>
    ),
  },
  {
    id: 'uploadSpeedBandwidth',
    label: 'Upload Speed',
    width: '130px',
    format: (value: ScanDetails) => (
      <StyledTunnelStatus>
        {value && (
          <SGSubtitle className="s2">
            {value?.uploadSpeedThroughput} / {value?.uploadSpeedBandwidth}
          </SGSubtitle>
        )}
      </StyledTunnelStatus>
    ),
  },
  {
    id: 'downloadSpeedBandwidth',
    label: 'Download Speed',
    width: '140px',
    format: (value: ScanDetails) => (
      <StyledTunnelStatus>
        {value && (
          <SGSubtitle className="s2">
            {value?.downloadSpeedThroughput} / {value?.downloadSpeedBandwidth}
          </SGSubtitle>
        )}
      </StyledTunnelStatus>
    ),
  },
];
//#endregion Column Definitions

//#region Component
interface ModalContent {
  deviceType: DeviceType;
  devices: Device<ScanDetails>[];
  deviceName?: string;
}

export default function NodeModalContent({devices, deviceType, deviceName}: ModalContent) {
  const severity = getPriorityAlert(devices);
  const hasIssues = Number(SeverityPriorityEnum[severity.toUpperCase() as any]) > 1;

  return (
    <StyledModalContent>
      <ModalIconTitle
        deviceType={deviceType}
        severity={hasIssues ? severity : undefined}
        deviceName={deviceName ? deviceName : ''}
      />
      <ModalMainContentContainer>
        {devices.map(device => (
          <DataRow
            columns={networkCircuitColumns}
            data={device.scanResults as ScanDetails}
            alerts={device.alerts}
          ></DataRow>
        ))}
      </ModalMainContentContainer>
    </StyledModalContent>
  );
}
//#endregion Component
